import React, { useState, useRef, useEffect } from "react";
import "../styles/Downbar.css";
import { FaBars, FaDice, FaMoneyBillWave, FaGift, FaHeadset } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { usePayment } from "../context/PaymentContext";
import { useTranslation } from "react-i18next";
import AuthModal from "./AuthModal";

const Downbar = ({ onMenuClick }) => {
  const { openPaymentModal } = usePayment();
  const navigate = useNavigate();
  const { isAuth } = useAuth();
  const isMobile = window.innerWidth <= 768;
  const { t, i18n } = useTranslation();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const location = useLocation();
  const [indicatorStyle, setIndicatorStyle] = useState({ left: 0, width: 0 });
  const btnRefs = [useRef(), useRef(), useRef(), useRef(), useRef()];

  // Определяем активную вкладку по location.pathname
  const getActiveTab = () => {
    if (location.pathname === "/") return 0;
    if (location.pathname.startsWith("/bonuses")) return 2;
    if (location.pathname.startsWith("/support")) return 3;
    if (location.pathname.startsWith("/menu")) return 4;
    return 0;
  };
  const [activeTab, setActiveTab] = useState(getActiveTab());

  useEffect(() => {
    setActiveTab(getActiveTab());
  }, [location.pathname]);

  // Анимируем индикатор
  useEffect(() => {
    const ref = btnRefs[activeTab]?.current;
    if (ref) {
      const rect = ref.getBoundingClientRect();
      const parentRect = ref.parentNode.getBoundingClientRect();
      setIndicatorStyle({
        left: rect.left - parentRect.left,
        width: rect.width
      });
    }
  }, [activeTab, btnRefs, isMobile]);

  if (!isMobile) return null;

  const handleDepositClick = () => {
    if (isAuth) {
      openPaymentModal({ type: "deposit" });
    } else {
      setShowAuthModal(true);
    }
  };

  const handleAuthModalClose = () => {
    setShowAuthModal(false);
  };

  const handleLoginSuccess = () => {
    window.location.reload();
  };

  return (
    <>
      <div className="downbar">
        <div className="downbar-indicator" style={{ left: indicatorStyle.left, width: indicatorStyle.width }} />
        <button ref={btnRefs[0]} className={`downbar-btn${activeTab === 0 ? " active" : ""}`} onClick={() => { setActiveTab(0); navigate("/"); }}>
          <FaDice />
          <span>{t("downBar.casino")}</span>
        </button>
        <button ref={btnRefs[1]} className={`downbar-btn${activeTab === 1 ? " active" : ""}`} onClick={() => { setActiveTab(1); handleDepositClick(); }}>
          <FaMoneyBillWave />
          <span>{t("downBar.deposit")}</span>
        </button>
        <button ref={btnRefs[2]} className={`downbar-btn${activeTab === 2 ? " active" : ""}`} onClick={() => { setActiveTab(2); navigate("/bonuses"); }}>
          <FaGift />
          <span>{t("sidebar.bonuses", "Бонусы")}</span>
        </button>
        <button ref={btnRefs[3]} className={`downbar-btn${activeTab === 3 ? " active" : ""}`} onClick={() => { setActiveTab(3); window.open('https://t.me/oncaspins', '_blank', 'noopener,noreferrer'); }}>
          <FaHeadset />
          <span>{t("downBar.support")}</span>
        </button>
        <button ref={btnRefs[4]} className={`downbar-btn${activeTab === 4 ? " active" : ""}`} onClick={() => { setActiveTab(4); onMenuClick(); }}>
          <FaBars />
          <span>{t("downBar.menu")}</span>
        </button>
      </div>
      {showAuthModal && (
        <AuthModal
          onClose={handleAuthModalClose}
          isLoginType={true}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </>
  );
};

export default Downbar;

